<template>
  <div>
    <b-modal
      id="NewGroupModal"
      ref="NewGroupModal"
      size="lg"
      content-class="menu-bg-blue-transparent-modal ngm-modal"
      title="Create Group"
      hide-footer
     
      @show="initModal()"
    >
      <b-container>
        <b-form-input
          name="New Group Name"
          placeholder="Group Name"
          autocomplete="off"
          v-model="form.group_name"
        />
        <b-row class="p-3">
          <b-col class="text-center">
            <b-button
              class="btn-lg float-right"
              variant="primary"
              type="submit"
              @click="checkForm()"
            >
              Submit
            </b-button>
          </b-col>
          <b-col class="text-center">
            <b-button
              class="btn-lg float-left"
              variant="secondary"
              type="button"
              @click="back()"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<style>
.ngm-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.ngm-modal .form-control {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
}
.ngm-modal .form-control::placeholder { color: rgba(6, 60, 109, 0.35); }
.ngm-modal .form-control:focus {
  background: #fff !important;
  border-color: #063c6d !important;
  box-shadow: 0 0 0 2px rgba(6, 60, 109, 0.12) !important;
}
</style>

<script>
import axios from 'axios'
export default {
  name: 'MMP_NewGroupModal',
  data() {
    return {
      form: {
        group_name: null
      },
      formSubmitErrors: [],
      groups: []
    }
  },
  methods: {
    initModal() {
      this.getGroups()
    },
    back() {
      this.$bvModal.hide('NewGroupModal')
    },
    getGroups() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/groups', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Groups API Call Error: ' + content.errors)
            } else {
              this.groups = content.rows.map(row => {
                return row.group ? row.group : 'None'
              })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    checkForm() {
      this.formSubmitErrors = []
      if (!this.form.group_name) {
        this.formSubmitErrors.push('Name required.')
      }
      if (this.groups.includes(this.form.group_name)) {
        this.formSubmitErrors.push('Group already exists.')
      }
      if (!this.formSubmitErrors.length) {
        this.submitGroup()
      }
    },
    submitGroup() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/addGroup', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-token': sessionStorage.token
            },
            params: {
              group_name: this.form.group_name
            }
          })
          .then(response => {
            this.$bvModal.hide('NewGroupModal')
            this.$emit('newGroupAdded', response.data.msg != 'fail')
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    }
  }
}
</script>
